<script lang="ts" setup></script>

<template>
  <div
    role="status"
    class="relative min-w-[296px] h-[464px] animate-pulse rounded-lg border border-neutral-600/40 opacity-40 grid grid-rows-[296px_56px_64px_52px]">
    <div class="relative bg-neutral-600 rounded-t-lg">
      <div
        class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-secondary-900 p-2 rounded-lg">
        <svg
          class="h-12 w-12 text-neutral-600 opacity-40"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 640 512">
          <path
            d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
        </svg>
      </div>
    </div>
    <div
      class="flex items-center justify-center border-b border-neutral-600/40">
      <span class="bg-neutral-600 w-48 h-4 rounded-lg"></span>
    </div>
    <div
      class="flex items-start justify-between border-b border-neutral-600/40 px-2 pt-4">
      <span class="bg-neutral-600 w-20 h-3 rounded-lg"></span>
      <div class="flex flex-col items-end gap-2">
        <span class="bg-neutral-600 w-16 h-2 rounded-lg"></span>
        <span class="bg-neutral-600 w-10 h-2 rounded-lg"></span>
      </div>
    </div>
    <div class="flex items-center justify-center gap-2">
      <BaseIconAvatar class="w-9" />
      <span class="bg-neutral-600 w-20 h-2 rounded-lg"></span>
      <span class="sr-only">{{
        $t("main.loaderCardGridSkeleton.loading")
      }}</span>
    </div>
  </div>
</template>
